<template>
    <div>
        <div class="form-group" :class="{ 'is-invalid': hasError }">
            <label class="form-label">{{ label }}</label>

            <ul class="selector">
                <li v-for="option in options" :key="option.value" :class="{'active': value === option.text }">
                    <button @click.prevent="update(option)" v-text="option.text"></button>
                </li>

                <li :class="{ 'active': dataPlaceholder === 'other' }">
                    <button @click.prevent="update({ value: 'other', text: 'Anders..' })" value="other">Anders..</button>
                </li>
            </ul>
        </div>

        <div class="form-group" v-if="showOther">
            <label class="form-label" for="name">Namelijk..</label>
            <input id="name" class="form-control" type="text" required="required" v-model="otherOption">
        </div>
    </div>

</template>

<script>
	export default {
		props: ['label', 'options', 'value', 'hasError'],

		data () {
			return {
				dataPlaceholder: null,
				showOther: false,
				otherOption: null,
			}
		},

		mounted () {
			let selectedOption = this.options.filter((option) => {
				return option.text === this.value
			})

			if (selectedOption.length === 0 && this.value !== null ) {
				this.dataPlaceholder = 'other'
				this.showOther = true
				this.otherOption = this.value
			}
		},

		methods: {
			update (option) {
				this.dataPlaceholder = option.value
				this.$emit('input', option.text)
			},
		},

		watch: {
			dataPlaceholder (value) {
				if (value === 'other') {
					this.showOther = true
					this.$emit('input', this.otherOption)
				} else {
					this.showOther = false
				}
			},

			otherOption (value) {
				this.$emit('input', value)
			},
		},
	}
</script>